import { api } from './client'
import type { Group, GroupRole, GroupSummary } from '@/types'

export interface CreateGroupRequest {
  name: string
  memberSteamIds: string[]
  emoji?: string
}

export function fetchGroups(): Promise<Group[]> {
  return api.get<Group[]>('/groups')
}

export function fetchGroup(groupId: string): Promise<Group> {
  return api.get<Group>(`/groups/${groupId}`)
}

export function createGroup(data: CreateGroupRequest): Promise<Group> {
  return api.post<Group>('/groups', data)
}

export function updateGroup(
  groupId: string,
  data: { emoji?: string; name?: string; guidance?: string },
): Promise<Group> {
  return api.patch<Group>(`/groups/${groupId}`, data)
}

export function deleteGroup(groupId: string): Promise<void> {
  return api.delete<void>(`/groups/${groupId}`)
}

export function fetchGroupSummary(groupId: string): Promise<GroupSummary> {
  return api.get<GroupSummary>(`/groups/${groupId}/summary`)
}

export function addGroupMember(groupId: string, steamId: string): Promise<void> {
  return api.post<void>(`/groups/${groupId}/members`, { steamId })
}

export function removeGroupMember(groupId: string, steamId: string): Promise<void> {
  return api.delete<void>(`/groups/${groupId}/members/${steamId}`)
}

export function updateGroupMemberRole(
  groupId: string,
  steamId: string,
  role: GroupRole,
): Promise<void> {
  return api.patch<void>(`/groups/${groupId}/members/${steamId}`, { role })
}
